import React from 'react';
import { Link } from 'react-router-dom';

export const NotFound = ({ staticContext }) => {
  if (staticContext) {
    staticContext.statusCode = 404;
  }
  return (
    <div className={'content_page'}>
      <div className={'list_title_holder'}>
        <h1>Deze pagina bestaat niet.</h1>
        <div className={'text_block'}>
          <p>
            Klik <Link to="/">hier</Link> om naar Dumpert te gaan.
          </p>
        </div>
      </div>
    </div>
  );
};
